import "./SolutionsSubpagesAdditionalTreatments.module.css";
import Header from "@/reusable_sections/Header";
import AboutLinda from "./sections/AboutLinda";
import PortStanley from "./sections/PortStanley";
import OurServices from "./sections/OurServices";
import DestinationGrid from "./sections/DestinationGrid";
import WhyChooseUs from "./sections/WhyChooseUs";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import TaXappFeatureShowcase from "./sections/TaXappFeatureShowcase";
import ShippingCoverage from "./sections/ShippingCoverage";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsSubpagesAdditionalTreatmentsPage() {
  return <div>
      <Header />
      <AboutLinda />
      <PortStanley />
      <OurServices />
      <DestinationGrid />
      <WhyChooseUs />
      <TaXappFeatureShowcase />
      <ShippingCoverage />
      <CustomerTestimonials />
      <Booking />
      <Footer />
    </div>;
}